document.addEventListener("DOMContentLoaded", function(event) { 
    const experiments = document.getElementsByClassName('exp-container');

    for (const experiment of experiments) {
        const expName = experiment.getAttribute('data-expname');
        const variant = experiment.getAttribute('data-variant');

        if (!!expName && !!variant) {
            if(mixpanel && mp_params && !mixpanel.__loaded) {
                /* If mixpanel wasn't loaded yet, add experiment directly to window */
                mp_params.experiments.push({
                    'name' : expName,
                    'variant' : variant
                });
            } else if(mixpanel && mixpanel.__loaded && typeof mp_track_event === "function") {
                /* If mixpanel is already loaded, call track function directly */
                mp_track_event('$experiment_started', {
                    'Experiment name': expName,
                    'Variant name': variant,
                });
            }
        }
    }
});
